export default __webpack_public_path__ + "static/media/profile.7bdd4997.svg";